export default "__VITE_ASSET__BdM00cWZ__"